import { createAction, props } from '@ngrx/store';

export const setAutonomyAction = createAction(
  '[AUTONOMY] Set Autonomy',
  props<{ Autonomy: string }>()
);
